<template>
  <div>
    <v-row>
      <v-col>
        <v-btn @click="Insert()">เพิ่ม</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table :headers="headers" :items="desserts" class="elevation-1">
          <template v-slot:item.action="{ item }">
            <v-btn fab dark small color="lime" @click="Edit(item)">
              <v-icon dark>fa fa-pen</v-icon>
            </v-btn>
            <v-btn fab dark small color="red" @click="Delete(item)">
              <v-icon dark>fa fa-trash-alt</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      headers: [
        {
          text: "ระดับสมาชิก",
          align: "left",
          sortable: true,
          value: "UserLevelText.TH",
        },
        {
          text: "ชื่อสมาชิก",
          align: "left",
          sortable: true,
          value: "UserName",
        },
        {
          text: "สวนยาง",
          align: "left",
          sortable: true,
          value: "Rubber.RubberName",
        },
        {
          text: "เบอร์โทรศัพท์",
          align: "left",
          sortable: true,
          value: "UserTel",
        },
        {
          text: "หมายเหตุ",
          align: "left",
          sortable: true,
          value: "UserRemark",
        },
        {
          text: "วันที่สมัคร",
          align: "left",
          sortable: true,
          value: "CreatedText",
        },
        { width: 120, text: "", value: "action", sortable: false },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.Select();
    });
  },
  methods: {
    Select() {
      axios.get("/api/v1/select/SelectByLevel/user?Level=O,W").then((res) => {
        if (res.status == 200) {
          this.desserts = res.data;
        }
      });
    },
    Edit(v) {
      this.PassAccept("update", () => {
        this.$router.push("/member/add?UserId=" + v.UserId);
      });
    },
    Delete(v) {
      this.PassAccept("delete", () => {
        axios
          .delete("/api/v1/delete/delete/user?UserId=" + v.UserId)
          .then((res) => {
            if (res.status == 200) {
              this.Select();
            }
          });
      });
    },
    Insert() {
      this.$router.push("/member/add");
    },
  },
};
</script>
<style></style>
